module.exports = __webpack_public_path__ + "static/media/term-img.7a813865.svg";